<template>
    <div>
      <p>糖尿病被认为是21世纪的一大瘟疫。据估计，高达20%的糖尿病患者需要住院治疗，因为足部出现溃疡，再加上循环系统的问题，如果再加上缺乏冲洗和感染的情况，这种情况会在不止几次的情况下导致肢体丧失。</p>
      <p>因此，糖尿病足的治疗和治疗需要多学科的方法。在Centro Bioenergy，我们专门关注是否作为基于草药产品的辅助产品、中西医结合以及不同医疗外科技术的应用。</p>
    </div>
</template>

<script>
export default {
  name: 's3'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/s3.vue